import RaidPlan, { RaidPlanCast } from 'app/frontend/types/custom/RaidPlan'
import Difficulty from 'app/frontend/types/custom/Difficulty'

export const IMPORTABLE_DIFFICULTIES = ['mythic', 'heroic'] as const

export const defaultSelectedTab = (
  difficulty: Difficulty,
): typeof IMPORTABLE_DIFFICULTIES[number] =>
  IMPORTABLE_DIFFICULTIES.includes(
    difficulty as typeof IMPORTABLE_DIFFICULTIES[number],
  )
    ? (difficulty as typeof IMPORTABLE_DIFFICULTIES[number])
    : 'mythic'

export type WarcraftLogsImportKill = {
  id: number | string
  reportCode: string
  fightId: number
  fightDurationMs: number
  timeline: unknown
  rank?: number
  difficulty?: Difficulty
}

export const formatFightDuration = (durationMs: number) => {
  const totalSeconds = Math.max(0, Math.floor(durationMs / 1000))
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60
  return `${minutes}:${seconds.toString().padStart(2, '0')}`
}

export const getTopExecutionKillTimeline = (kill: WarcraftLogsImportKill) => {
  return kill.timeline as RaidPlan['timeline']
}

export const cloneActorCasts = (casts: RaidPlanCast[]) => {
  return JSON.parse(JSON.stringify(casts)) as RaidPlanCast[]
}
